import React from "react";
import { EnterpriseCompanies } from "../../../components/admin/Dashboard/mycompanies/EnterpriseCompanies";
const Enterprise = () => {
  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-4 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          <EnterpriseCompanies />
        </div>
      </div>
    </>
  );
};

export default Enterprise;
